import { createContext } from 'react'

export default createContext({
  tracker: null
})
